module.exports = __webpack_public_path__ + "static/img/yuangong.5b91e438.png";